import { useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useThrottle } from '@toss/react';
import { useTranslation } from 'next-i18next';
import { Input } from '@/ui/components/input';
import { Button } from '@/ui_v3';
import { INPUT_MAX_LENGTH, SignSelectSchoolGrade, SignSelectSchoolType } from '../../form';
import { type SchoolFormData } from './SchoolSearchModal';
interface SchoolSearchInputProps {
  onSearch: (searchQuery: string) => void;
  isSearched: boolean;
}
export const SchoolSearchInput = ({
  onSearch,
  isSearched
}: SchoolSearchInputProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    control
  } = useFormContext<SchoolFormData>();
  const schoolName = useWatch({
    control,
    name: 'schoolName'
  });
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = useThrottle(() => {
    onSearch(searchQuery);
  }, 1000);
  return <div className="flex gap-xs" data-sentry-component="SchoolSearchInput" data-sentry-source-file="SchoolSearchInput.tsx">
      <Input className="border-input-border h-[47px] w-full rounded-sm border-[1px]" placeholder={t('signup.school.searchPlaceholder')} value={isSearched ? schoolName : searchQuery} onChange={e => setSearchQuery(e.target.value)} onKeyDown={e => {
      if (e.key === 'Enter') {
        handleSearch();
      }
    }} maxLength={INPUT_MAX_LENGTH} data-sentry-element="Input" data-sentry-source-file="SchoolSearchInput.tsx" />
      <Button size="lg" intent={isSearched ? 'alternative' : 'strong'} variant={isSearched ? 'outlined' : 'contained'} onClick={handleSearch} className="min-w-[120px]" data-sentry-element="Button" data-sentry-source-file="SchoolSearchInput.tsx">
        {isSearched ? t('global.reSearch') : t('global.search')}
      </Button>
    </div>;
};
export const SchoolSearchManualInput = () => {
  const {
    control,
    setValue,
    clearErrors
  } = useFormContext<SchoolFormData>();
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex flex-col gap-xs px-lg" data-sentry-component="SchoolSearchManualInput" data-sentry-source-file="SchoolSearchInput.tsx">
      <Controller name="schoolName" control={control} defaultValue="" render={({
      field
    }) => <div className="flex flex-col gap-3xs">
            <Input className="border-input-border h-[47px] w-full rounded-sm border-[1px]" placeholder={t('signup.school.namePlaceholder')} value={field.value || ''} onChange={e => {
        field.onChange(e);
      }} maxLength={INPUT_MAX_LENGTH} />
            <div className="pl-xs text-caption-md-medium text-assistive">
              {t('signup.school.searchModalDescription')}
            </div>
          </div>} data-sentry-element="Controller" data-sentry-source-file="SchoolSearchInput.tsx" />
      <Controller name="schoolType" control={control} render={({
      field
    }) => <SignSelectSchoolType value={field.value} onValueChange={e => {
      field.onChange(e);
      if (e === 'COLLEGE' || e === 'OTHER' || e === 'KINDERGARTEN') {
        setValue('schoolGrade', '0', {
          shouldValidate: true
        });
        setValue('schoolGradeCode', 'noGradeCode', {
          shouldValidate: true
        });
      } else {
        setValue('schoolGrade', '', {
          shouldValidate: true
        });
        setValue('schoolGradeCode', '', {
          shouldValidate: true
        });
      }
    }} />} data-sentry-element="Controller" data-sentry-source-file="SchoolSearchInput.tsx" />
      <Controller name="schoolGrade" control={control} render={({
      field
    }) => <SignSelectSchoolGrade value={field.value} onValueChange={e => {
      clearErrors('schoolGradeCode');
      field.onChange(e);
    }} />} data-sentry-element="Controller" data-sentry-source-file="SchoolSearchInput.tsx" />
    </div>;
};